package app.nestbridge.app.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import app.nestbridge.app.screen.AppEvent
import app.nestbridge.app.screen.AppScreen
import app.nestbridge.app.screen.AppState
import com.slack.circuit.codegen.annotations.CircuitInject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(screen = AppScreen::class, scope = AppScope::class)
@Composable
fun AppUi(state: AppState, modifier: Modifier = Modifier) {
    LaunchedEffect(Unit) {
        state.eventSink(AppEvent.OnAppear)
    }

    Box(modifier = modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        CircularProgressIndicator()
    }
}
